import React from "react";
import { OverviewContainer } from "../../../containers";
const Overview = (props) => {
  return <OverviewContainer {...props} />;
};

export default Overview;
